import { FilePlus2, FileUp, Plus } from 'lucide-react';
import type { ReactElement, ReactNode } from 'react';

import { ActionsMenu, type MenuAction } from '@/components/ui/ActionsMenu';
import { ExportMenu } from '@/components/ui/ExportMenu';
import { useExportReport } from '@/components/ui/use-export-report';

// Acciones del encabezado de la Lista Maestra. Si caben en el encabezado (`.actions-wide`):
// todos los botones. Si no (`.actions-narrow`, móvil): la acción principal y el resto en
// "Más acciones" (Columnas no aplica: en móvil la lista se muestra como tarjetas).

const EXPORT_PATH = '/api/v1/quality/master-list/export';
const TITLE = 'Lista Maestra';

interface Props {
  /** Vista de documentos (no la bandeja de solicitudes): Columnas y Exportar. */
  listActions: boolean;
  exportQuery: string;
  /** Selector de columnas (solo escritorio). */
  columns: ReactNode;
  onImport?: () => void;
  onRequest?: () => void;
  onCreate?: () => void;
}

export function MasterListActions({
  listActions,
  exportQuery,
  columns,
  onImport,
  onRequest,
  onCreate,
}: Props): ReactElement {
  const { run } = useExportReport(EXPORT_PATH, exportQuery, TITLE);
  const more: MenuAction[] = [
    ...(listActions
      ? [
          { label: 'Exportar en CSV', onSelect: () => run('csv') },
          { label: 'Exportar en PDF', onSelect: () => run('pdf') },
        ]
      : []),
    ...(onImport ? [{ label: 'Importar desde Excel', onSelect: onImport }] : []),
    ...(onRequest ? [{ label: 'Solicitar documento', onSelect: onRequest }] : []),
  ];

  return (
    <div className="pagehead-actions">
      <div className="actions-wide">
        {listActions && (
          <>
            {columns}
            <ExportMenu path={EXPORT_PATH} query={exportQuery} title={TITLE} />
          </>
        )}
        {onImport && (
          <button className="btn mut" type="button" onClick={onImport}>
            <FileUp aria-hidden="true" strokeWidth={1.9} />
            Importar desde Excel
          </button>
        )}
        {onRequest && (
          <button className="btn mut" type="button" onClick={onRequest}>
            <FilePlus2 aria-hidden="true" strokeWidth={1.9} />
            Solicitar documento
          </button>
        )}
      </div>
      {more.length > 0 && (
        <div className="actions-narrow">
          <ActionsMenu items={more} />
        </div>
      )}
      {onCreate && (
        <button className="btn" type="button" onClick={onCreate}>
          <Plus aria-hidden="true" strokeWidth={1.9} />
          Nuevo documento
        </button>
      )}
    </div>
  );
}
